import './EvoSong.css';

const platforms = [
  {
    id: 'spotify',
    name: 'Spotify',
    svg: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    ),
    href: 'https://open.spotify.com/intl-fr/album/78WL2dwTJ3gGDVaVScXZII?si=bgnzrDOUTO-cWaG9UFNg2A',
  },
  {
    id: 'apple',
    name: 'Apple Music',
    svg: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
      </svg>
    ),
    href: 'https://music.apple.com/fr/song/la-chanson-devo/1886418393',
  },
  {
    id: 'youtube',
    name: 'YouTube Music',
    svg: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0zm0 19.104c-3.924 0-7.104-3.18-7.104-7.104S8.076 4.896 12 4.896s7.104 3.18 7.104 7.104-3.18 7.104-7.104 7.104zm0-13.332c-3.432 0-6.228 2.796-6.228 6.228S8.568 18.228 12 18.228s6.228-2.796 6.228-6.228S15.432 5.772 12 5.772zM9.684 15.54V8.46L15.816 12z"/>
      </svg>
    ),
    href: 'https://youtu.be/GPaflCqPaY4?si=hm5Hr8GbQWXp2xD2',
  },
  {
    id: 'deezer',
    name: 'Deezer',
    svg: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M18.944 18.057h3.388v1.005h-3.388zm-4.497 0h3.388v1.005h-3.388zm-4.498 0h3.39v1.005h-3.39zm-4.497 0H8.84v1.005H5.452zm13.492-2.46h3.388v1.005h-3.388zm-4.497 0h3.388v1.005h-3.388zm-4.498 0h3.39v1.005h-3.39zm-4.497 0H8.84v1.005H5.452zm13.492-2.46h3.388v1.003h-3.388zm-4.497 0h3.388v1.003h-3.388zm-4.498 0h3.39v1.003h-3.39zm8.995-2.461h3.388v1.004h-3.388zm-4.497 0h3.388v1.004h-3.388zm4.497-2.46h3.388v1.004h-3.388zm-4.497 0h3.388v1.004h-3.388zm4.497-2.459h3.388v1.004h-3.388z"/>
      </svg>
    ),
    href: 'https://link.deezer.com/s/32Q0WdYSJXQ3aZbSgfuZm',
  },
];

export default function EvoSong() {
  return (
    <section className="evosong">
      {/* Blobs arrière-plan */}
      <div className="evosong__blob evosong__blob--1" />
      <div className="evosong__blob evosong__blob--2" />
      <div className="evosong__blob evosong__blob--3" />

      {/* Notes flottantes décoratives */}
      <span className="evosong__note evosong__note--1" aria-hidden="true">♪</span>
      <span className="evosong__note evosong__note--2" aria-hidden="true">♫</span>
      <span className="evosong__note evosong__note--3" aria-hidden="true">♩</span>
      <span className="evosong__note evosong__note--4" aria-hidden="true">♬</span>

      <div className="container evosong__inner">

        {/* ── Pochette + vinyl ── */}
        <div className="evosong__visual" aria-hidden="true">
          <div className="evosong__vinyl">
            <div className="evosong__vinyl-groove" />
            <div className="evosong__vinyl-center" />
          </div>
          <div className="evosong__cover-wrap">
            <img
              src="/images/la-chanson-d-evo-evolify-app.jpg"
              alt="Pochette — La chanson d'EVO"
              className="evosong__cover"
            />
            <div className="evosong__cover-shine" />
          </div>
          {/* Badge "NOW PLAYING" */}
          <div className="evosong__now-playing">
            <span className="evosong__now-playing-dot" />
            Disponible maintenant
          </div>
        </div>

        {/* ── Contenu ── */}
        <div className="evosong__content">

          {/* Label */}
          <div className="evosong__badge">
            <span className="evosong__badge-dot" />
            🎵 Musique exclusive Evolify
          </div>

          {/* Égaliseur animé */}
          <div className="evosong__eq" aria-label="Lecture en cours">
            {[0, 1, 2, 3, 4, 5, 6].map((i) => (
              <span key={i} className="evosong__eq-bar" style={{ '--i': i }} />
            ))}
          </div>

          <h2 className="evosong__title">
            La chanson<br />
            <span className="evosong__title-gradient">d'EVO</span>
          </h2>
          <p className="evosong__meta">Par Evolify · Bande originale officielle</p>
          <p className="evosong__desc">
            Une mélodie entraînante et joyeuse créée spécialement pour accompagner vos enfants dans leur motivation. Attention ! Ils la chanteront bientôt à tue tête ! ;)  ✨
          </p>

          {/* Plateformes */}
          <p className="evosong__platforms-label">Disponible sur toutes les plateformes</p>
          <div className="evosong__platforms">
            {platforms.map((p) => (
              <a
                key={p.id}
                href={p.href}
                className={`evosong__platform evosong__platform--${p.id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {p.svg}
                <span>{p.name}</span>
              </a>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
